<template>
    <section class="auth-page">
        <!-- This div is used for style purpose -->
        <div></div>

        <form @submit.prevent="submitForm" type="POST" class="auth-page--form">
            <img class="auth-page--logo" src="@/assets/logo_dark.png" alt="XMLShopconnector">

            <input type="email" v-model="email" id="email" :placeholder="$translate.text('general.email')">

            <input
                type="password"
                v-model="password"
                id="password"
                :placeholder="$translate.text('general.password')"
            >

            <button type="submit" class="button button--rounded">{{ t('auth.login') }}</button>
        </form>
        <div class="footer-items">
            <router-link class="bold dashboard-item" :to="{ name: 'DashboardContent' }">{{ t('general.goto.dashboard') }}</router-link>
            <router-link class="bold dashboard-item" :to="{ name: 'ForgotPassword' }">{{ t('auth.forgot_password') }}?</router-link>
        </div>
    </section>
</template>
<script>
import handleError from '@/helpers/error';

export default {
    name: 'LoginPage',

    data() {
        return {
            email: '',
            password: '',
        };
    },

    methods: {
        submitForm() {
            NProgress.start();

            this.$http
                .login(this.email, this.password)
                .then(response => {
                    this.$http
                        .setTokens(response)
                        .then(tokens => {
                            this.API.setToken(tokens.access_token);

                            this.$http
                                .getUser()
                                .then(() => {
                                    NProgress.done();

                                    this.$router.go();
                                })
                                .catch(e => {
                                    handleError({
                                        error: e,
                                        message: this.$translate.text(
                                            'auth.me.error',
                                        ),
                                    });
                                });
                        })
                        .catch(err => {
                            handleError({
                                error: err,
                                message: this.$translate.text(
                                    'auth.set_tokens.error',
                                ),
                            });
                        });
                })
                .catch(error => {
                    if (error.response.data.error === 'disabled') {
                        handleError({
                            error,
                            message: this.$translate.text('auth.login.sub.error'),
                        });
                    } else {
                        handleError({
                            error,
                            message: this.$translate.text('auth.login.error'),
                        });
                    }
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.auth-page {
    width: 100%;
    min-height: 100vh;
    background-color: $bluegrey;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &--logo {
        width: 100%;
        height: auto;
        max-width: 400px;
        margin-bottom: 48px;
    }

    &--form {
        padding: 20px;
        display: flex;
        flex-direction: column;
        width: 400px;

        input {
            margin-bottom: 8px;
            border: 0;
            border-radius: 4px;
            height: 40px;
            text-align: center;
            font-size: 16px;
        }

        button {
            margin-top: 16px;
        }
    }

    a {
        margin-bottom: 24px;
        color: $blue;
        text-decoration: none;

        &:hover {
            color: darken($blue, 10%);
        }
    }
    .bold {
        font-weight: 700;
    }

    .footer-items {
        padding-bottom: 20px;

        .dashboard-item {
            margin-left:20px;
            margin-right:20px;
        }
    }
}
</style>
